export const PAGE_TITLES_AND_CONTENT = {
    termsName: 'Terms & Conditions',
    terms_link: 'https://www.mapfreinsurance.com/en/terms-conditions/',
    P_S_name: 'Privacy Policy',
    P_S_link: 'https://www.mapfreinsurance.com/en/privacy-policy/',
    hereToHelp_text: `We're here to help`,
    copy_right_text: 'MAPFRE U.S.A Corp. All rights reserved',

};